export default "__VITE_ASSET__DKVWFiM4__"